<template>
  <div class="Tetgeleg">
    <div class="container">
      <div class="Tetgeleg_top">
        <div class="row">
          <div class="col-md-3">
            <h3>Тэтгэлэг </h3>
          </div>
          <div class="col-md-9">
            <div class="total">
              {{ gridTitle }}: {{total | number }}
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
<!--          <a href="javascript:void(0)" @click="cleanFilter" class="clean_button">Цэвэрлэх</a>-->
          <div class="main_left">
            <h3>Он, сар</h3>
            <a href="javascript:void(0)" @click="cleanFilter" class="clean_button"><i class="fa fa-refresh"></i></a>
            <div class="list">
              <Select v-model="select_jil" placeholder="Он сонгох">
                <Option v-for="jil in jils" :value="jil.id" :key="jil.id">{{ jil.on_jil }} он</Option>
              </Select>
            </div>
            <div class="list">
              <Select v-model="select_sar" placeholder="Сар сонгох">
                <Option v-for="item in sars" :value="item.id" :key="item.id">{{ item.title }} - сар</Option>
              </Select>
            </div>
          </div>
          <div class="main_left">
            <h3>Аймаг</h3>
            <div class="list">
              <CheckboxGroup v-model="filtered_aimag">
                <div class="checkbox" :key="index" v-for="(aimag, index) in aimags">
                  <Checkbox :label="aimag.id">{{ aimag.aimagname }}<span></span></Checkbox>
                </div>
              </CheckboxGroup>
            </div>
          </div>
          <div class="main_left">
            <h3>Сургалтын байгууллага</h3>
            <div class="list">
              <CheckboxGroup v-model="filtered_baiguullagga">
                <div class="checkbox" :key="index" v-for="(school, index) in filteredSchools">
                  <Checkbox :label="school.id">{{ school.school_title }}<span></span></Checkbox>
                </div>
              </CheckboxGroup>
            </div>
          </div>
          <div class="haih">
            <Button class="button" @click="saveData"><i class="fa fa-search"></i>Хайх</Button>
          </div>
        </div>
        <div class="col-md-9">
          <div class="main_table">
            <table width="100%">
              <thead>
              <tr>
                <th>№</th>
                <th>АНГИ БҮЛЭГ</th>
                <th>ОВОГ</th>
                <th>НЭР</th>
                <th>РЕГИСТРИЙН ДУГААР</th>
                <th>ИРЦ</th>
                <th>ТӨЛӨВ</th>
              </tr>
              </thead>
              <tbody>
              <tr :key="index" v-for="(data, index) in datas">
                <td>
                  <span v-if="current_page == 1">{{ index + 1 }}</span>
                  <span v-else>{{ ((current_page - 1) * 20) + (index + 1) }}</span>
                </td>
                <td>{{ data.classner }}</td>
                <td>{{ data.ovogstudent }}</td>
                <td>{{ data.studentner }}</td>
                <td>{{ data.register.slice(0, 10) }}</td>
                <td>{{ data.irtsiin_huvi }}%</td>
                <td class="true_green" v-if="data.tetgeleg_avsan_eseh == 1">Олгогдсон</td>
                <td class="true_red" v-else>Олгогдоогүй</td>
              </tr>

              </tbody>
            </table>
          </div>
          <div class="tetgeleg_page">
            <Page @on-change="changePage"
                  :current-page="current_page"
                  :page-size="9"
                  :total="total"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getTetgelegFilterData, getTetgelegData} from "../api/index"


export default {

  computed: {
    filteredSchools() {
      if (this.filtered_aimag.length >= 1) {
        return this.schools.filter(school => {
          if (this.filtered_aimag.findIndex(aimag => aimag == school.aimag_id) >= 0) {
            return true
          } else {
            return false
          }
        });
      } else {
        return this.schools;
      }
    },
    gridTitle() {
      if (this.filtered_aimag.length >= 1) {
        let title = "";
        this.aimags.forEach(aimag => {
          if (this.filtered_aimag.findIndex(aimag_id => aimag_id == aimag.id) >= 0) {
            if (title != "")
              title = title + ", " + aimag.aimagname;
            else
              title = aimag.aimagname;
          }
        });
        return  title;
      } else {
        return "Улсын хэмжээнд";
      }
    }
  },
  data() {
    return {
      current_page: 1,
      last_page: 1,
      total: 0,
      TetgelegFilterData: {},
      select_jil: null,
      select_sar: null,
      filtered_aimag: [],
      jils: [],
      sars: [],
      filtered_baiguullagga: [],
      aimags: [],
      schools: [],
      datas: []
    }
  },
  mounted() {
    this.calldata();
    this.saveData();
  },
  methods: {
    calldata() {
      this.$isLoading(true);
      getTetgelegFilterData().then(response => {
        this.TetgelegFilterData = response.data;
        this.aimags = response.data.aimags;
        this.schools = response.data.schools;
        this.jils = response.data.jils;
        this.sars = response.data.sars;

        this.$isLoading(false);
      }).catch(error => {
        this.$Loading.error();
        console.log('ErrorL ', error);
      });
    },
    cleanFilter() {
      this.select_jil =  null;
      this.select_sar =  null;
      this.filtered_aimag =  [];
      this.filtered_baiguullagga =  [];
      this.saveData();
    },
    saveData() {
      this.$isLoading(true);
      getTetgelegData(this.current_page, {
        school_ids: this.filtered_baiguullagga,
        aimag_ids: this.filtered_aimag,
        jil_id: this.select_jil,
        sard_id: this.select_sar,
      }).then(response => {
        this.$isLoading(false);
        // if(response.data.status == 'false'){
        this.datas = response.data.data;
        this.current_page = response.data.current_page;
        this.total = response.data.total;
        console.log(this.datas);
        // }else
        // {
        //     this.$Loading.error();
        //     console.log("aldaa");
        // }
      }).catch(error => {
        this.$Loading.error();
        console.log('ErrorL ', error);
      });
    },
    changePage(page) {
      this.current_page = page;
      this.saveData();
    },

  },
}
</script>
